export class TokenResponse {
  accessToken: string
  isEmployee: boolean
  refreshToken: string

  constructor(accessToken: string, isEmployee: boolean, refreshToken: string) {
    this.accessToken = accessToken
    this.isEmployee = isEmployee
    this.refreshToken = refreshToken
  }
}
